export interface SwiklyCustomer {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
}

export interface CreateDepositPayload {
  accountId?: string;
  amount: number;                 // Montant (ex: 500.00)
  currency: 'EUR' | 'USD' | 'GBP';
  description?: string;
  reference?: string;             // Référence interne (booking id…)
  customer?: SwiklyCustomer;
  redirectSuccessUrl?: string;
  redirectCancelUrl?: string;
  expirationDays?: number;        // Validité du lien en jours
  captureMode?: 'manual' | 'auto';
  env?: 'sandbox' | 'production'; // Pour votre backend
}

export interface CreateDepositResponse {
  depositId: string;
  url: string;                    // Lien de caution à partager
}

const base = (b?: string) => (b && b.trim()) || '/api/swikly';

async function http<T>(input: RequestInfo, init?: RequestInit): Promise<T> {
  const res = await fetch(input, {
    headers: { 'Content-Type': 'application/json', ...(init?.headers || {}) },
    ...init
  });
  if (!res.ok) {
    const text = await res.text().catch(() => '');
    throw new Error(text || `HTTP ${res.status}`);
  }
  return res.json() as Promise<T>;
}

export const SwiklyService = {
  async ping(baseUrl?: string, apiKey?: string): Promise<{ ok: true }> {
    return http<{ ok: true }>(`${base(baseUrl)}/ping`, {
      headers: apiKey ? { 'x-swikly-api-key': apiKey } : undefined
    });
  },
  async createDeposit(payload: CreateDepositPayload, baseUrl?: string, apiKey?: string): Promise<CreateDepositResponse> {
    return http<CreateDepositResponse>(`${base(baseUrl)}/deposits`, {
      method: 'POST',
      body: JSON.stringify(payload),
      headers: apiKey ? { 'x-swikly-api-key': apiKey } : undefined
    });
  },
  async getDepositStatus(depositId: string, baseUrl?: string, apiKey?: string, accountId?: string): Promise<{ id: string; status: string; amount: number; currency: string; createdAt?: string }> {
    const qs = accountId ? `?accountId=${encodeURIComponent(accountId)}` : '';
    return http(`${base(baseUrl)}/deposits/${encodeURIComponent(depositId)}${qs}`, {
      headers: apiKey ? { 'x-swikly-api-key': apiKey } : undefined
    });
  },
  async cancelDeposit(depositId: string, baseUrl?: string, apiKey?: string, accountId?: string): Promise<{ id: string; status: string }> {
    const qs = accountId ? `?accountId=${encodeURIComponent(accountId)}` : '';
    return http(`${base(baseUrl)}/deposits/${encodeURIComponent(depositId)}/cancel${qs}`, {
      method: 'POST',
      headers: apiKey ? { 'x-swikly-api-key': apiKey } : undefined
    });
  },
};
